import { CapoPlugin } from "/codebuild/output/src4255038753/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];